import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AppIdentityCompositeEntity } from '@nk/data-entities-lib';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { DigestService } from './digest.service';

@Injectable()
export class DigestRedirectGuard {
  public identity: AppIdentityCompositeEntity;

  constructor(
    private _router: Router,
    private _digestService: DigestService,
  ) {}

  public canActivate(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    let digestUuid = childRoute.firstChild.paramMap.get('uuid');
    let digest = null;
    let redirectToWatchlist = false;

    const urlSegments = state.url.split('/');

    // We dont know if this is a digest uuid or any UUID.
    if (urlSegments.indexOf('watchlist') >= 0) {
      digestUuid = childRoute.firstChild.paramMap.get('uuid');
    } else {
      redirectToWatchlist = true;
    }

    if (digestUuid) {
      return this._digestService.digestCache.get(digestUuid).pipe(
        mergeMap((payload) => {
          digest = payload;
          if (digest && redirectToWatchlist) {
            const watchlistUuid = digest.watchlist_uuid;
            this._router.navigate(['/watchlist', watchlistUuid, 'digest', digestUuid]);
            return of(false);
          } else {
            return of(true);
          }
        }),
      );
    } else {
      this._router.navigate(['/watchlist/']);
    }
  }
}
